import { gql } from 'graphql-request';
import { merchantServiceGraphql } from '../config/Config';

export const getDashboardData = async () => {
  const currentDate = new Date();
  const lastWeekDate = new Date(currentDate.getTime() - 604800000);
  const userRole = localStorage.getItem('userRole');

  const startDate = lastWeekDate.toISOString().split('T')[0];
  const endDate = currentDate.toISOString().split('T')[0];

  const variables = {
    filter: { StartDate: startDate, EndDate: endDate },
    sortField: 'updated_at',
    sortOrder: 'ASC',
    getTransactionSortField: 'transdate',
  };

  try {
    const getDashboardQuery = () => {
      switch (userRole) {
        case '1':
          return DASHBOARD_QUERY_ROLE_1;
        case '2':
          return DASHBOARD_QUERY_ROLE_2;
        case '3':
          return DASHBOARD_QUERY_ROLE_3;
        default:
          throw new Error('Unknown role');
      }
    };
    const DASHBOARD = getDashboardQuery();

    let response = await merchantServiceGraphql.request(DASHBOARD, variables);

    // Cashier doesn't have permission to get: allSubMerchants
    if (userRole !== '3') {
      const numberOfTerminal = response.allSubMerchants.reduce(
        (total, subMerchant) => {
          return total + subMerchant.apollo_terminal.length;
        },
        0
      );
      if (numberOfTerminal > 0) {
        response.transactionsGroupedBySubMerchant =
          await getTransactionByListSubMerchant(
            response.allSubMerchants,
            startDate,
            endDate,
            userRole
          );
      } else response.transactionsGroupedBySubMerchant = [];
    }

    // Except Master Manager, other roles use getTransactionByContract instead.
    if (userRole === '1')
      response = {
        ...response,
        listTransaction: response.getTransactionByMerchant,
      };
    else
      response = {
        ...response,
        listTransaction: response.getTransactionByContract,
      };

    return response;
  } catch (err) {
    console.log(
      'Error when calling API or Handling API response for Dashboard'
    );
    throw err;
  }
};

const getTransactionByListSubMerchant = async (
  allSubMerchants,
  startDate,
  endDate,
  userRole
) => {
  // Generate query string
  const queryContract =
    userRole === '1' ? 'getTransactionByContract' : 'getTransactionByContract';

  let QUERY = 'query getTransactionByListSubMerchant {';
  for (let i = 0; i < allSubMerchants.length; i++) {
    const ele_subMer = allSubMerchants[i];
    if (ele_subMer.apollo_terminal.length > 0) {
      for (let j = 0; j < ele_subMer.apollo_terminal.length; j++) {
        const ele_ter = allSubMerchants[i].apollo_terminal[j];
        QUERY += `
        trans_${ele_subMer.id}_${ele_ter.id}: ${queryContract}(filter: {
          TerminalID: ${ele_ter.id},
          StartDate: "${startDate}",
          EndDate: "${endDate}",
        }) {
          id
          netamount
        }`;
      }
    }
  }
  QUERY += '}';

  let response = await merchantServiceGraphql.request(QUERY);

  // Group response object by Merchant ID
  const groupBySubMerchantID = (items) => {
    // Group by SubMerchant ID
    const result = Object.keys(items).reduce(
      (result, item) => ({
        ...result,
        [item.split('_')[1]]: {
          id: item.split('_')[1],
          name: allSubMerchants.find(
            (ele) => ele.id === parseInt(item.split('_')[1])
          ).name,
          data: [
            ...(result[item.split('_')[1]]?.data || []),
            ...response[item],
          ],
        },
      }),
      {}
    );

    return result;
  };

  return groupBySubMerchantID(response);
};

const DASHBOARD_QUERY_ROLE_1 = gql`
  query Dashboard($filter: TransactionWhereInput) {
    allTerminals {
      id
      status
      terminal_code
      created_at
      updated_at
    }
    allEmployees {
      id
      username
      fullname
      phone
      email
      address
      role
      status
      created_at
      updated_at
    }
    getTransactionByMerchant(filter: $filter) {
      id
      transdate
      transtypeid
      netamount
    }
    allSubMerchants {
      id
      name
      apollo_terminal {
        id
      }
    }
  }
`;

const DASHBOARD_QUERY_ROLE_2 = gql`
  query Dashboard($filter: TransactionWhereInput) {
    allTerminals {
      id
      status
      terminal_code
      created_at
      updated_at
    }
    allEmployees {
      id
      username
      fullname
      phone
      email
      address
      role
      status
      created_at
      updated_at
    }
    getTransactionByContract(filter: $filter) {
      id
      transdate
      transtypeid
      netamount
    }
    allSubMerchants {
      id
      name
      apollo_terminal {
        id
      }
    }
  }
`;

const DASHBOARD_QUERY_ROLE_3 = gql`
  query Dashboard($filter: TransactionWhereInput) {
    getTransactionByContract(filter: $filter) {
      id
      transdate
      transtypeid
      netamount
    }
  }
`;
